import React from 'react';
import { useForm, useFormState } from 'react-hook-form';

import { Message } from '@components';
import { FormFieldset, TextField } from '@Forms/fields.jsx';
import { urlFormat } from '@Forms/formatters.js';
import { errorsFromMutate } from '@Forms/utils.js';
import { ButtonSpinnerIcon } from '@svgs';

export const TemplateSettingsForm = ({ disabled, mutation, siteData }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setError,
  } = useForm({
    defaultValues: siteData,
    mode: 'onBlur',
  });
  const { isDirty, isValid } = useFormState({ control });

  const onSubmit = (data) => {
    // just save the title and not other parts of payload
    data = {
      title: data.title,
    };
    mutation.mutate(data, {
      onError: (error) => {
        // handle server-side validations and errors
        const errorsList = errorsFromMutate(error);
        errorsList.forEach(({ field, error }) => {
          setError(field, error);
        });
      },
    });
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit)}
      className={
        `sb-manage-content-form ` + (disabled ? 'sb-form-disabled' : '')
      }
    >
      <FormFieldset>
        <TextField
          register={register}
          error={errors.title}
          options={{ required: 'This field is required' }}
          name="title"
          label="Template name"
          placeholder="Your Brand Local Template"
          helpText="Internal name for your template"
        />
      </FormFieldset>
      <div className="sb-manage-content-button-bar">
        <div className="sb-flex">
          {/*<button className="sb-btn-cancel sb-btn" onClick={resetForm}>Cancel</button>*/}
          <button
            type="submit"
            className="sb-btn sb-btn-save"
            disabled={disabled}
          >
            {mutation.isPending ? 'Publishing...' : 'Publish changes'}
            {mutation.isPending && <ButtonSpinnerIcon />}
          </button>
        </div>
        {!isValid && isDirty && (
          <Message messageStyle="error" title="Please review your form" />
        )}
        {mutation.isError && (
          <Message
            messageStyle="error"
            title="Error saving changes"
            message="Please review your form"
          />
        )}
        {mutation.isSuccess && (
          <Message messageStyle="success" title="Successfully saved" />
        )}
      </div>
    </form>
  );
};
